// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bp-4";
export var collapsed = "_bp-1";
export var headerBar = "_bp-0";
export var leftHeaderContent = "_bp-3";
export var subjectContainer = "_bp-2";